import { WebsocketClientType } from '../../../enum/shared/websocket-client-type';

export class WebSocketConnectionInfo {
  constructor(
    public clientId: string,
    public clientType: WebsocketClientType,
    public locationId: number
  ) {
    this.clientId = clientId;
    this.clientType = clientType;
    this.locationId = locationId;
  }
}
